// extracted by mini-css-extract-plugin
export var borderRadius = "_ak-4";
export var large = "_ak-3";
export var logoContainer = "_ak-0";
export var nameLogo = "_ak-2";
export var small = "_ak-1";